import { configProvider } from '@/common/app-config/public/configuration-provider';

interface AppConfig {
  apiUrl: string;
  clientId: string;
  clientSecret: string;
}

export function getEndpointConfig(): AppConfig {
  const expectedKeys = ['VITE_APP_API_URL', 'VITE_APP_API_CLIENT_ID', 'VITE_APP_API_CLIENT_SECRET'];
  if (expectedKeys.every(key => import.meta.env[key])) {
    return {
      apiUrl: import.meta.env.VITE_APP_API_URL ?? '',
      clientId: import.meta.env.VITE_APP_API_CLIENT_ID ?? '',
      clientSecret: import.meta.env.VITE_APP_API_CLIENT_SECRET ?? '',
    };
  }

  return configProvider.get();
}
